export default "__VITE_ASSET__BVKUb26t__"